<script>
import { defineComponent } from 'vue'
import NeuralNetwork from "@/components/homepage/NeuralNetwork.vue";
import SvgIcon from "@/assets/icon/index.vue";

export default defineComponent({
  name: "NeuralNetAll",
  components: { SvgIcon, NeuralNetwork }
})
</script>

<template>
  <div class="play-title">
    <!-- 装饰光斑 -->
    <span class="orb orb-1" />
    <span class="orb orb-2" />

    <!-- 神经网络铺满底层 -->
    <div class="line-title">
      <NeuralNetwork />
    </div>

    <!-- 标题内容 -->
    <div class="title-inner">
      <h1 class="text-title">Hello World</h1>
      <p class="subtitle">探索 · 创造 · 分享</p>
    </div>

    <!-- Logo 装饰 -->
    <div class="logo" aria-hidden="true">
      <svg-icon icon-class="logo" />
    </div>
  </div>
</template>

<style scoped>
.play-title {
  position: relative;
  height: 180px;
  border-radius: 20px;
  overflow: hidden;          /* 关键:裁掉溢出的装饰 */
  isolation: isolate;
  user-select: none;
  /* 深蓝紫底 + 双径向光晕,有纵深 */
  background:
      radial-gradient(120% 140% at 0% 0%, #7c5cff 0%, transparent 55%),
      radial-gradient(120% 140% at 100% 100%, #2a6bff 0%, transparent 55%),
      linear-gradient(135deg, #4b3fbf 0%, #2b3a8f 45%, #16204d 100%);
  box-shadow:
      0 18px 40px -18px rgba(45, 55, 140, 0.55),
      inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

/* 光斑:柔和浮动,替代生硬纯色 */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.6;
  pointer-events: none;
  z-index: 0;
}
.orb-1 {
  width: 220px; height: 220px;
  background: #9d7bff;
  top: -80px; left: -60px;
  animation: float 8s ease-in-out infinite;
}
.orb-2 {
  width: 260px; height: 260px;
  background: #4f8dff;
  bottom: -120px; right: -60px;
  animation: float 10s ease-in-out infinite reverse;
}
@keyframes float {
  0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
  50% { transform: translate3d(20px, 14px, 0) scale(1.08); }
}

/* 神经网络:铺满整层,置于标题下方 */
.line-title {
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: 0.55;
  pointer-events: none;
}

/* 标题内容:flex 布局,不再靠魔法数字 */
.title-inner {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 8%;
  gap: 8px;
}

/* 去掉实色背景块,直接做渐变文字 + 投影 */
.text-title {
  margin: 0;
  font-family: "华文新魏", "STXinwei", serif;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(90deg, #ffffff 0%, #d9ccff 50%, #a9c2ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}

.subtitle {
  margin: 0;
  font-size: 14px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.72);
}

/* Logo:垂直居中、靠右,transform 防飞出 */
.logo {
  position: absolute;
  right: 6%;
  top: 50%;
  transform: translateY(-50%) rotate(-8deg);
  font-size: 110px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.16);
  z-index: 1;
  pointer-events: none;
}

/* 响应式 */
@media (max-width: 768px) {
  .play-title { height: 150px; border-radius: 16px; }
  .title-inner { padding-left: 6%; }
  .logo { font-size: 80px; }
}

@media (prefers-reduced-motion: reduce) {
  .orb { animation: none; }
}
</style>